import { render, staticRenderFns } from "./percentage.vue?vue&type=template&id=56b47d39&scoped=true&"
import script from "./percentage.vue?vue&type=script&lang=js&"
export * from "./percentage.vue?vue&type=script&lang=js&"
import style0 from "./percentage.vue?vue&type=style&index=0&id=56b47d39&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b47d39",
  null
  
)

export default component.exports